import React from 'react';

export default function LoadingIndicator({card}) {
    return (
        <div className="LoadingIndicator">
            <div className="lds-dual-ring"/>
        </div>
    );
}